
import Vue from 'vue'
import store from "@/store";

// 检测权限
function checkPermission(value) {
    if (!value) return false;

    let user = store.getters.user;
    let editRole = store.getters.editRole;
    if (user.usertype < 4) {
        return true
    } else {
        if (editRole[value] && editRole[value] == 2) {
            return true
        } else {
            return false
        }
    }
}

const has = Vue.directive('has', {
    inserted: function (el, binding) {
        if (!checkPermission(binding.value)) {
            el.parentNode.removeChild(el);
        }
    }
});

export { has }